<div class="teams-list-component">
  <div class="col-md-12 no-padding">
    <legend>Teams</legend>
    <div class="trips-tab-body">
      <lgt-grid-static
        [cols]="cols"
        [data]="teams"
        [selectCol]="true"
        [onDblClick]="viewDetail"
        [showPrintInvoice]="false"
        [showNewButton]="true"
        [newButtonOptions]="newButtonOptions"
        [newButtonAction]="newButtonAction"
        [filters]="filters"
        [loadData]="loadData"
        [showExcelButton]="true"
        [onExcelButton]="excelGeneration"
        [useSignalR]="false"
        [pageName]="'teams-list'"
      />
    </div>
  </div>
</div>